import { gql } from '@apollo/client';

import { CALCULATED_CREATIVE_DATA_WITH_COUNTRIES } from '../../fragments';

export const GET_CALCULATED_CREATIVE_DATA_FOR_AD_BY_ASSET_AND_COUNTRY_LIST = gql`
  query calculatedCreativeDataForAdByAssetAndCountryList(
    $assetIdList: [String!]!
    $creativeType: String!
    $countryList: [String!]!
    $publisherList: [String!]!
  ) {
    getCalculatedCreativeDataForAdByAssetAndCountryList(
      assetIdList: $assetIdList
      creativeType: $creativeType
      countryList: $countryList
      publisherList: $publisherList
    ) {
      ...calculatedCreativeDataWithCountries
    }
  }
  ${CALCULATED_CREATIVE_DATA_WITH_COUNTRIES}
`;
